class AuthorBooks extends HTMLElement {
  connectedCallback() {
    this.load();
  }

  async load() {
    const name = this.dataset.authorName;
    const handle = this.dataset.authorHandle;
    const searchUrl = this.dataset.searchUrl;
    const catalogUrl = this.dataset.catalogUrl;
    const section = this.querySelector('[data-ref="section"]');
    const results = this.querySelector('[data-ref="results"]');
    const existingHandles = new Set((this.dataset.existingHandles || '').split('|').filter(Boolean));

    if (!name || !handle || !section || !results) return;

    if (catalogUrl) {
      const catalogLoaded = await this.loadFromCatalog({ catalogUrl, handle, existingHandles, section, results });
      if (catalogLoaded) return;
    }

    if (!searchUrl) return;
    await this.loadFromSearch({ name, searchUrl, existingHandles, section, results });
  }

  async loadFromCatalog({ catalogUrl, handle, existingHandles, section, results }) {
    const matchedItems = [];
    let pageNumber = 1;
    let totalPages = 1;

    try {
      do {
        const separator = catalogUrl.includes('?') ? '&' : '?';
        const response = await fetch(`${catalogUrl}${separator}view=author-books&page=${pageNumber}`, {
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = documentFragment.querySelector('[data-author-catalog-results]');
        if (!source) throw new Error('Missing author catalog results');

        totalPages = Math.min(Number.parseInt(source.dataset.totalPages || '1', 10), 20);
        source.querySelectorAll('[data-author-book-handle]').forEach((item) => {
          const productHandle = item.dataset.authorBookHandle;
          const authorHandles = item.dataset.authorHandles || '';
          if (authorHandles.includes(`|${handle}|`) && !existingHandles.has(productHandle)) {
            existingHandles.add(productHandle);
            matchedItems.push(item);
          }
        });

        pageNumber += 1;
      } while (pageNumber <= totalPages);

      this.showResults({ matchedItems, section, results });
      return true;
    } catch (error) {
      return false;
    }
  }

  async loadFromSearch({ name, searchUrl, existingHandles, section, results }) {

    const params = new URLSearchParams({
      view: 'author-books',
      type: 'product',
      'options[prefix]': 'last',
      q: `"${name}"`
    });

    try {
      const response = await fetch(`${searchUrl}?${params.toString()}`, {
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = documentFragment.querySelector('[data-author-book-results]');
      if (!source) throw new Error('Missing author results');

      source.querySelectorAll('[data-author-book-handle]').forEach((item) => {
        if (existingHandles.has(item.dataset.authorBookHandle)) item.remove();
      });

      if (source.querySelector('[data-author-book-handle]')) {
        results.replaceChildren(...source.childNodes);
        section.hidden = false;
        window.ManifestAuthorLinks?.resolve(results);
      }
    } catch (error) {}
  }

  showResults({ matchedItems, section, results }) {
    if (!matchedItems.length) return;

    const list = document.createElement('ul');
    list.className = 'c-product-grid c-product-grid--block';
    list.setAttribute('role', 'list');
    list.append(...matchedItems);
    results.replaceChildren(list);
    section.hidden = false;
    window.ManifestAuthorLinks?.resolve(results);
  }
}

if (!customElements.get('author-books')) {
  customElements.define('author-books', AuthorBooks);
}
